export interface Post {
  id: string;
  author: string;
  content: string;
  timestamp: number;
  likes: number;
}

export interface MemeTemplate {
  id: string;
  name: string;
  url: string;
}

export interface GeneratedMeme {
  url: string;
  prompt: string;
}

export enum GameState {
  IDLE = 'IDLE',
  PLAYING = 'PLAYING',
  GAME_OVER = 'GAME_OVER'
}
